module.exports = __webpack_public_path__ + "static/media/Gangplank_0.af544611.jpg";